import Ovate from "../../assets/images/pontics/ovate.png";
import Saddle from "../../assets/images/pontics/saddle.png";
import Conical from "../../assets/images/pontics/conical.png";
import RidgeLop from "../../assets/images/pontics/ridge-lop.png";
import Spheroidal from "../../assets/images/pontics/spheroidal.png";
import ModifiedRidgeLop from "../../assets/images/pontics/modified-ridge-lop.png";
import ModifiedSpheroidal from "../../assets/images/pontics/modified-spheroidal.png";

export const SHADE_OPTIONS = [
  "A1",
  "A2",
  "A3",
  "A3.5",
  "A4",
  "B1",
  "B2",
  "B3",
  "B4",
  "C1",
  "C2",
  "C3",
  "C4",
  "D2",
  "D3",
  "D4"
] as const;

export const PONTIC_DESIGNS = [
  { value: "Saddle Pontic", image: Saddle },
  { value: "Ridge Lap Pontic", image: RidgeLop },
  { value: "Modified Ridge Lap Pontic", image: ModifiedRidgeLop },
  { value: "Ovate Pontic", image: Ovate },
  { value: "Conical Pontic", image: Conical },
  { value: "Spheroidal Pontic", image: Spheroidal },
  { value: "Modified Spheroidal Pontic", image: ModifiedSpheroidal }
] as const;

export const DENTAL_ITEMS = [
  "Zirconia Bridge",
  "Zirconia Crown",
  "E-max Bridge",
  "E-max Crown",
  "P.F.M. Bridge",
  "P.F.M. Crown",
  "Implant Zirconia Crown",
  "Implant Crown P.F.M.",
  "Metal Crown",
  "Gold Crown",
  "Jack Screw",
  "Begg's Retainer",
  "Nickel Free PFM",
  "C.D.",
  "R.P.D.",
  "Flexible C.D.",
  "Flexible R.P.D.",
  "Clear Retainer",
  "Hawley's Retainer",
  "Anterior Bite Plate",
  "Hyrax",
  "Monoblock",
  "Night Guard",
  "TPA",
  "Wax with Bite",
  "Registration",
  "Study Cast",
  "Temporary Crown",
  "Temporary Bridge",
  "Mock Up",
  "CPD",
  "Space Maintainer",
  "Aligner",
  "Maxillary Cast",
  "Mandibular Cast",
  "Patient Photographer"
] as const;

export const TEETH_NUMBERS = {
  TOP: [18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28].map(String),
  BOTTOM: [48, 47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37, 38].map(String)
} as const;

export const OCCLUSAL_STAIN_OPTIONS = ["none", "light", "medium", "dark"] as const;
